import { Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { faCircleXmark } from "@fortawesome/pro-light-svg-icons";
import { CustomerListDto } from "../../api/types";
import useModal from "antd/es/modal/useModal";
import FaIcon from "../../components/FaIcon";
import GlobalCustomerSelectField from "./GlobalCustomerField";
import { useFavourites } from "../../hooks/userFavourites";
import { unwrap, usersSetFavourites } from "../../api";

interface Props {
  onCustomerChange: (customer: CustomerListDto) => void;
  selectedCustomer?: Partial<CustomerListDto>;
  closeModal: () => void;
}

// TopbarCustomers style classes
const styleClasses = `
  whitespace-nowrap h-[35px] flex justify-center items-center
  transition-[border-color,background] duration-300
  rounded-[var(--corner)] cursor-pointer
  [&_span]:leading-[1.2rem]
  [&_div]:flex-1 [&_div]:py-0 [&_div]:px-2
`;

function ModalForm(props: Props) {
  const [form] = Form.useForm();

  function onFinish(values: any) {
    props.onCustomerChange(values.customer);
    props.closeModal();
  }
  const isEditingPage = window.location.pathname.includes("edit");
  return (
    <Form
      form={form}
      id="form"
      initialValues={{ customer: props.selectedCustomer }}
      labelAlign={"left"}
      layout="vertical"
      scrollToFirstError
      onValuesChange={onFinish}
    >
      <Form.Item name={"customer"}>
        <GlobalCustomerSelectField all disabled={isEditingPage} />
      </Form.Item>
    </Form>
  );
}

const TopbarCustomers = () => {
  const { t } = useTranslation();

  const [modal, modalContext] = useModal();

  const { favourites, setFavourites } = useFavourites({ enabled: true });

  const sidebarFavourites = favourites?.sidebarFavourites ?? [];
  const selectedCustomer = favourites?.selectedCustomer;
  async function setSelectedCustomer(newSelectedCustomer: CustomerListDto) {
    const payload = {
      sidebarFavourites,
      selectedCustomer: newSelectedCustomer,
      id: "",
    };
    setFavourites(payload);
    await unwrap(usersSetFavourites({ body: { data: JSON.stringify(payload) } }));
  }

  function showModal() {
    const modalInstance = modal.info({
      title: t("Select customer"),
      content: (
        <ModalForm closeModal={closeModal} selectedCustomer={selectedCustomer} onCustomerChange={setSelectedCustomer} />
      ),
      okButtonProps: { style: { display: "none" } },
      icon: undefined,
      closable: true,
      closeIcon: <FaIcon icon={faCircleXmark} />,
      onCancel: () => {
        closeModal();
      },
      transitionName: "",
      maskTransitionName: "",
    });
    function closeModal() {
      modalInstance.destroy();
    }
  }

  function getLabel() {
    if (selectedCustomer) {
      return selectedCustomer.name;
    }
    return t("All");
  }

  return (
    <div key={"customer"} className={`gray-box primary ${styleClasses}`} data-cy={"language-switcher-language"}>
      {modalContext}
      <div
        onClick={() => {
          showModal();
        }}
      >
        <span>{t("Customer")}</span>: {getLabel()}
      </div>
    </div>
  );
};

export default TopbarCustomers;
